import { takeEvery, put } from 'redux-saga/effects'
import * as a from '../actions'

const feedback = (action, payload) =>
  () => takeEvery(action, () => put(a.showAppFeedback(payload)))

const ok = (action, message, autoHideDuration = 3000) =>
  feedback(action, { message, action: 'ok', autoHideDuration })

const error = (action, message, autoHideDuration = 3000) =>
  feedback(action, { message, action: 'error', autoHideDuration })

const er = error


function* watchForMissionDependant() {
  yield takeEvery(a.MISSION_PRE_SELECT_FETCH, function* x({ payload }) {
    const dependant = payload.dependants.map(d => d.name)
    if (dependant.length > 0) {
      yield put(a.showAppFeedback({ message: `Debes completar la misión
     ${dependant.join()}`,
        action: 'OK',
        autoHideDuration: 3000 }))
    }
  })
}

export default [
  er(a.USER_NOT_FOUND, 'Usuario no encontrado.'),
  ok(a.USER_LOGGED_IN, 'Bienvenido.'),
  ok(a.USER_LOGGED_OUT, 'Sesión cerrada.'),
  ok(a.USER_RECOVERY_PASS_SUCCEEDED,
    'Se te envió un correo para recuperar tu contraseña.'),
  ok(a.BUY_PRIZE_SUCCEEDED, 'Compra exitosa.'),
  ok(a.CHECKIN_DONE, 'Checkin realizado correctamente.'),
  er(a.BUY_PRIZE_FAILED, 'No se pudo efectuar la compra.'),
  watchForMissionDependant,
]



// WEBPACK FOOTER //
// ./src/sagas/user_feedback.jsx